import React from 'react';

const Hero = () => (
  <section className="relative min-h-[100svh] flex flex-col items-center justify-center text-center px-5 overflow-hidden">
    <p
      className="text-[10px] sm:text-[11px] tracking-[0.5em] uppercase text-muted mb-7 md:mb-10"
      style={{ animation: 'fadeUp .9s .1s both' }}
    >
      Fotografía documental
    </p>

    <h1
      className="font-display font-black leading-[0.9] tracking-[-0.03em] text-ink text-[clamp(2.6rem,11vw,7.5rem)]"
      style={{ animation: 'fadeUp 1s .2s both' }}
    >
      <span className="block">Sebastian</span>
      <span className="block">Chuffer</span>
    </h1>

    <p
      className="font-serif italic text-muted text-[clamp(1rem,3.4vw,1.6rem)] tracking-wide mt-7 md:mt-9"
      style={{ animation: 'fadeUp .9s .5s both' }}
    >
      Diferencia y Repetición
    </p>

    <button
      onClick={() => document.getElementById('galeria')?.scrollIntoView({ behavior: 'smooth' })}
      className="absolute bottom-9 flex flex-col items-center gap-2 text-muted hover:text-ink transition-colors"
      style={{ animation: 'fadeUp 1s .8s both' }}
      aria-label="Ver galería"
    >
      <span className="text-[10px] tracking-[0.32em] uppercase">Ver galería</span>
      <span className="block w-px h-8 bg-current" />
    </button>
  </section>
);

export default Hero;
